export default "__VITE_ASSET__7a3b6fb5__"